import { PATH_PAGE } from 'src/routes/paths';

// 사용자 매뉴얼을 팝업 창으로 연다. 이미 열려 있으면 같은 창을 다시 쓴다.
export const openUserManual = (section: string) => {
  const manualWindow = window.open(
    `${PATH_PAGE.userManual}#${section}`,
    'nicojini-user-manual',
    'width=1100,height=900',
  );
  manualWindow?.focus();
};
